import React from 'react';
import { connect } from 'dva';
import { injectIntl } from 'react-intl';
import MeetingBillReportDetail from '../components/report/MeetingBillReportDetail';

export default connect(state => ({ ...state, loading: state.loading.global }))(
  injectIntl(({ meetingBillReport, account, loading, intl, dispatch }) => {
    return (
      <div className="container-left">
        <MeetingBillReportDetail
          intl={intl}
          dispatch={dispatch}
          meetingBillReport={meetingBillReport}
          loading={loading}
          account={account}
        />
      </div>
    );
  })
);



// WEBPACK FOOTER //
// ./src/routes/MeetingBillReport.js